import { render } from "./DepartmentObjectDisplay.vue?vue&type=template&id=2d598fa0&scoped=true&ts=true"
import script from "./DepartmentObjectDisplay.vue?vue&type=script&lang=ts"
export * from "./DepartmentObjectDisplay.vue?vue&type=script&lang=ts"

import "./DepartmentObjectDisplay.vue?vue&type=style&index=0&id=2d598fa0&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d598fa0"]])

export default __exports__